import type { CreateAxiosDefaults } from "axios";
import axios from "axios";
import { EBff, getUrlBFF } from "./baseUrls";

const axiosConfig: CreateAxiosDefaults = {
	baseURL: getUrlBFF(EBff.FGTS),
};

const axiosConfigEP: CreateAxiosDefaults = {
	baseURL: getUrlBFF(EBff.EP),
};

export const apiClientEPService = axios.create(axiosConfigEP);
export const apiClientService = axios.create(axiosConfig);
